import {
    LOAD_ACCESS_TOKEN,
    REFRESH_TOKEN_SUCCESS,
    REMOVE_OLD_TOKEN,
    UNAUTHORIZED_ACCESS,
    UNAUTHORIZED_TOKEN_REFRESH,
    USER_LOGIN_FAILURE,
    USER_LOGIN_SUCCESS,
    USER_LOGOUT,
} from '../../actions/authentication';

const accessToken = (state = null, action = undefined) => {
    switch (action.type) {
        case USER_LOGIN_SUCCESS:
            return action.payload;
        case LOAD_ACCESS_TOKEN:
            return action.payload;
        case REFRESH_TOKEN_SUCCESS:
            return action.payload;
        case USER_LOGIN_FAILURE:
            return null;
        case UNAUTHORIZED_TOKEN_REFRESH:
            return null;
        case UNAUTHORIZED_ACCESS:
            return null;
        case USER_LOGOUT:
            return null;
        case REMOVE_OLD_TOKEN:
            return null;
        default:
            return state;
    }
};

export default accessToken;
